import React from 'react';
import { ScreenHeader } from '../components/ScreenHeader';
import { MetaLabel } from '../components/MetaLabel';
import { CheckControl } from '../components/CheckControl';
import { useShoot } from '../contexts/ShootContext';
export function Kit() {
  const {
    kitGroups,
    isKitChecked,
    toggleKit,
    countChecked,
    production
  } = useShoot();
  const allIds = kitGroups.flatMap(group => group.items.map(item => item.id));
  return <div className="pb-10" data-id="element-69" data-mp="mtv38zmr1gph">
      <ScreenHeader eyebrow="Kit List" title="Kit" meta={`Packed for ${production.title || 'this shoot'} only — not an inventory.`} action={<span className="pt-1 text-right" data-id="element-71" data-mp="wsudgmn5xkel">
            <span className="font-display text-2xl font-semibold tabular-nums tracking-display text-fg" data-id="element-72" data-mp="rs6enesozz9t">
              {countChecked(allIds, 'kit')}
            </span>
            <span className="font-display text-2xl font-semibold tabular-nums tracking-display text-dim" data-id="element-73" data-mp="284lgiq60lnug">
              /{allIds.length}
            </span>
          </span>} data-id="element-70" data-mp="mv65uw4gkif0" />

      {kitGroups.map(group => {
      const ids = group.items.map(item => item.id);
      return <section key={group.id} aria-label={group.title} className="mt-8" data-id="element-74" data-mp="bfcnhm09nxsl">
            <div className="flex items-baseline justify-between border-b border-line px-5 pb-3" data-id="element-75" data-mp="ghlggid52zup">
              <MetaLabel as="h2" tone="bright" data-id="element-76" data-mp="kgkkm0r1qsl3">
                {group.title}
              </MetaLabel>
              <span className="text-[11px] tabular-nums text-dim" data-id="element-77" data-mp="3jyk575rizcfi">
                {countChecked(ids, 'kit')} / {ids.length}
              </span>
            </div>

            {group.items.length === 0 && <p className="px-5 pt-4 text-[13px] text-dim" data-id="element-78" data-mp="3swdzkb5qbw01">Nothing added to this section yet.</p>}

            <ul data-id="element-79" data-mp="1l45hs8v3n8o">
              {group.items.map(item => {
            const checked = isKitChecked(item.id);
            return <li key={item.id} className="flex items-center gap-4 border-b border-line pl-5" data-id="element-80" data-mp="357l2ucha9k4d">
                    <span className="min-w-0 flex-1 py-4" data-id="element-81" data-mp="cd2zzds1k3d6">
                      {/* 9 Sep 2026: brought in line with Shots.tsx/Crew.tsx's
                          row-title spec (Archivo semibold, 18px) — this used
                          to be plain Inter text, the one list in the app not
                          using the shared "row title" treatment. */}
                      <span className={`block font-display text-[18px] font-semibold leading-tight tracking-display ${checked ? 'text-muted line-through' : 'text-fg'}`} data-id="element-82" data-mp="h6p2id4hqqv9">
                        {item.name}
                      </span>
                      {item.owner && <span className="mt-1 block text-[11px] text-dim" data-id="element-83" data-mp="3ui63wv69u9c0">{item.owner}</span>}
                    </span>
                    <span className="shrink-0 text-[13px] tabular-nums text-dim" data-id="element-84" data-mp="1dt0q3wt9ibaq">{item.qty}</span>
                    <CheckControl checked={checked} label={`Mark ${item.name} packed`} onToggle={() => toggleKit(item.id)} data-id="element-85" data-mp="19sgr0np4oxly" />
                  </li>;
          })}
            </ul>
          </section>;
    })}

      <p className="mt-8 px-5 text-[12px] leading-relaxed text-dim" data-id="element-86" data-mp="17gg0pzupl10e">
        Curated list for this shoot. Anything not on this list stays at the studio.
      </p>
    </div>;
}